// AUTO-GENERATED FILE.
// Do not edit manually.
// Source of truth: influencefinder_data Python config package.

export const DEFAULT_PLATFORM = "instagram";

export const LAUNCH_CITY_INDEX = [
  {
    "slug": "london",
    "name": "London",
    "aliases": [
      "london",
      "greater london",
      "london, uk",
      "city of london",
      "ldn",
      "romford",
      "ilford",
      "east london",
      "west london",
      "north london",
      "south london",
      "central london",
      "the big smoke",
      "london town",
      "westminster",
      "london bridge",
      "tower bridge",
      "canary wharf",
      "canarywharf",
      "london eye",
      "shoreditch",
      "soho",
      "camden",
      "islington",
      "angel",
      "dalston",
      "hoxton",
      "spitalfields",
      "brick lane",
      "bethnal green",
      "hackney",
      "clapham",
      "brixton",
      "peckham",
      "notting hill",
      "kensington",
      "chelsea",
      "fulham",
      "shepherds bush",
      "hammersmith",
      "earls court",
      "finsbury park",
      "stoke newington",
      "bermondsey",
      "lambeth",
      "walthamstow",
      "stratford",
      "leyton",
      "ealing",
      "acton",
      "wimbledon",
      "tooting",
      "putney",
      "richmond",
      "twickenham",
      "kingston upon thames",
      "kingston",
      "woolwich",
      "lewisham",
      "bromley",
      "croydon",
      "harrow",
      "uxbridge",
      "wembley",
      "greenwich",
      "thisislondon",
      "visitlondon",
      "londonlife",
      "londoncity",
      "lovelondon",
      "instalondon",
      "londonist",
      "igerslondon",
      "timeoutlondon",
      "prettycitylondon",
      "itssolondon",
      "ilovelondon",
      "mysecretlondon"
    ]
  },
  {
    "slug": "manchester",
    "name": "Manchester",
    "aliases": [
      "manchester",
      "greater manchester",
      "manchester city centre",
      "mcr",
      "salford",
      "stockport",
      "north west england",
      "manchester city",
      "cottonopolis",
      "rainy city",
      "bolton",
      "oldham",
      "rochdale",
      "trafford",
      "wigan",
      "bury",
      "tameside",
      "altrincham",
      "sale",
      "northern quarter",
      "chorlton",
      "didsbury",
      "ilovemcr",
      "visitmanchester",
      "manchesterbee",
      "wearemanchester",
      "mancmade"
    ]
  },
  {
    "slug": "birmingham",
    "name": "Birmingham",
    "aliases": [
      "birmingham",
      "brum",
      "birmingham city centre",
      "brummie",
      "bham",
      "west midlands",
      "second city",
      "coventry",
      "wolverhampton",
      "wolves",
      "solihull",
      "walsall",
      "dudley",
      "west bromwich",
      "sutton coldfield",
      "sandwell",
      "black country",
      "visitbirmingham",
      "thisisbirmingham",
      "ilovebrum",
      "brumlife"
    ]
  }
];

export const LAUNCH_NICHE_INDEX = [
  {
    "slug": "food_reviewers",
    "name": "Food Reviewers",
    "parent": "food",
    "group": "Food & Drink",
    "aliases": [
      "food reviewers",
      "food",
      "food reviewer",
      "restaurant reviewer",
      "local eats",
      "foodie",
      "food blogger",
      "food creator",
      "hidden gems",
      "hidden gem restaurants",
      "budget eats",
      "cheap eats",
      "places to eat",
      "where to eat",
      "food reels",
      "restaurant reels",
      "restaurant recommendations",
      "casual dining",
      "independent restaurants",
      "halal food reviewer",
      "vegan food reviewer",
      "brunch reviewer",
      "dessert reviewer",
      "street food reviewer",
      "date night restaurants",
      "lunch spots",
      "dinner spots"
    ]
  },
  {
    "slug": "coffee_brunch",
    "name": "Coffee, Brunch & Cafés",
    "parent": "food",
    "group": "Food & Drink",
    "aliases": [
      "coffee brunch",
      "coffee, brunch and cafés",
      "food",
      "brunch",
      "coffee",
      "cafe hopping",
      "cafés",
      "cafes",
      "breakfast spots",
      "bakery",
      "bakeries",
      "pastries",
      "dessert cafe",
      "coffee shops",
      "independent cafes",
      "brunch spots",
      "brunch review",
      "coffee blogger",
      "cafe reviewer",
      "bakery reviewer",
      "breakfast review",
      "matcha spots",
      "cake spots",
      "afternoon tea",
      "work from cafe",
      "laptop friendly cafe"
    ]
  },
  {
    "slug": "local_lifestyle",
    "name": "Local Lifestyle & City Guides",
    "parent": "local_lifestyle",
    "group": "Lifestyle",
    "aliases": [
      "local lifestyle",
      "local lifestyle and city guides",
      "city guide",
      "things to do",
      "hidden gems",
      "local events",
      "days out",
      "weekend plans",
      "places to visit",
      "local recommendations",
      "independent businesses"
    ]
  },
  {
    "slug": "beauty",
    "name": "Beauty & Makeup",
    "parent": "beauty",
    "group": "Beauty",
    "aliases": [
      "beauty",
      "beauty and makeup",
      "beauty creator",
      "makeup creator",
      "mua",
      "skincare routine",
      "beauty blogger",
      "grwm",
      "beauty reviewer",
      "self care",
      "makeup tutorial",
      "product review"
    ]
  },
  {
    "slug": "salon",
    "name": "Salons, Hair & Beauty Services",
    "parent": "beauty",
    "group": "Beauty",
    "aliases": [
      "salon",
      "salons, hair and beauty services",
      "beauty",
      "salon visit",
      "hair transformation",
      "beauty treatment",
      "haircare",
      "mua",
      "beauty creator",
      "self care",
      "hair colour transformation",
      "makeover"
    ]
  },
  {
    "slug": "hair_beauty",
    "name": "Hair, Salons & Barbers",
    "parent": "beauty",
    "group": "Beauty",
    "aliases": [
      "hair beauty",
      "hair, salons and barbers",
      "beauty",
      "hair transformation",
      "haircare",
      "barber lifestyle",
      "salon visit",
      "before and after hair",
      "hair colour",
      "curly hair",
      "hair journey",
      "men grooming"
    ]
  },
  {
    "slug": "nails_lashes",
    "name": "Nails, Brows & Lashes",
    "parent": "beauty",
    "group": "Beauty",
    "aliases": [
      "nails lashes",
      "nails, brows and lashes",
      "beauty",
      "nails",
      "nail art",
      "lashes",
      "brows",
      "beauty treatment",
      "lash lift",
      "brow lamination",
      "manicure",
      "biab nails"
    ]
  },
  {
    "slug": "indian_food",
    "name": "Indian & South Asian Food",
    "parent": "food",
    "group": "Food & Drink",
    "aliases": [
      "indian food",
      "indian and south asian food",
      "food",
      "south asian food",
      "desi food",
      "curry house",
      "halal food",
      "biryani",
      "dosa",
      "chaat",
      "street food",
      "local eats",
      "pakistani food",
      "bangladeshi food",
      "sri lankan food",
      "punjabi food",
      "gujarati food",
      "south indian food"
    ]
  },
  {
    "slug": "fitness",
    "name": "Fitness & Wellness",
    "parent": "fitness",
    "group": "Fitness",
    "aliases": [
      "fitness",
      "fitness and wellness",
      "fitness creator",
      "wellness creator",
      "gym lifestyle",
      "fitness journey",
      "transformation",
      "running",
      "yoga",
      "pilates",
      "healthy lifestyle",
      "strength training"
    ]
  },
  {
    "slug": "vegan",
    "name": "Vegan & Plant-Based",
    "parent": "food",
    "group": "Food & Drink",
    "aliases": [
      "vegan",
      "vegan and plant based",
      "food",
      "vegan food",
      "plant based",
      "vegan eats",
      "vegan restaurants",
      "vegan lifestyle",
      "cruelty free",
      "vegan brunch",
      "sustainable food",
      "meat free",
      "vegetarian food",
      "dairy free",
      "vegan dessert",
      "vegan cafe",
      "vegan takeaway"
    ]
  },
  {
    "slug": "skincare",
    "name": "Skincare Creators",
    "parent": "beauty",
    "group": "Beauty",
    "aliases": [
      "skincare",
      "skincare creators",
      "beauty",
      "skincare routine",
      "skin journey",
      "skincare creator",
      "beauty reviewer",
      "treatment review",
      "acne journey",
      "self care",
      "facial review",
      "spf routine"
    ]
  },
  {
    "slug": "aesthetics_clinic",
    "name": "Skin & Aesthetics Clinics",
    "parent": "beauty",
    "group": "Beauty",
    "aliases": [
      "aesthetics clinic",
      "skin and aesthetics clinics",
      "beauty",
      "aesthetics journey",
      "skin treatment",
      "facial treatment",
      "aesthetic nurse creator",
      "treatment review",
      "skincare creator",
      "beauty treatment",
      "skin clinic review",
      "facial review"
    ]
  },
  {
    "slug": "gym_training",
    "name": "Gyms & Personal Training",
    "parent": "fitness",
    "group": "Fitness",
    "aliases": [
      "gym training",
      "gyms and personal training",
      "fitness",
      "personal trainer",
      "fitness coach",
      "strength training",
      "gym lifestyle",
      "body transformation",
      "workout routine",
      "gym motivation",
      "fat loss journey",
      "muscle building"
    ]
  },
  {
    "slug": "yoga_pilates",
    "name": "Yoga, Pilates & Studios",
    "parent": "fitness",
    "group": "Fitness",
    "aliases": [
      "yoga pilates",
      "yoga, pilates and studios",
      "fitness",
      "yoga creator",
      "pilates creator",
      "reformer pilates",
      "wellness creator",
      "mindfulness",
      "movement creator",
      "yoga teacher creator",
      "pilates lifestyle",
      "stretch routine"
    ]
  },
  {
    "slug": "home_decor",
    "name": "Home Décor & Interiors",
    "parent": "home_decor",
    "group": "Home Decor",
    "aliases": [
      "home decor",
      "home décor and interiors",
      "interiors",
      "diy",
      "renovation",
      "cleaning creator",
      "home styling",
      "home organisation",
      "first home",
      "room makeover",
      "home hacks"
    ]
  }
];

export const LAUNCH_SEGMENT_INDEX = {
  "london": [
    "food_reviewers",
    "coffee_brunch",
    "local_lifestyle",
    "beauty",
    "salon",
    "hair_beauty",
    "nails_lashes",
    "indian_food",
    "fitness",
    "vegan",
    "skincare",
    "aesthetics_clinic",
    "gym_training",
    "yoga_pilates",
    "home_decor"
  ],
  "manchester": [
    "food_reviewers",
    "coffee_brunch",
    "local_lifestyle",
    "beauty",
    "salon",
    "hair_beauty",
    "nails_lashes",
    "fitness"
  ],
  "birmingham": [
    "food_reviewers",
    "coffee_brunch",
    "local_lifestyle",
    "beauty",
    "salon",
    "hair_beauty",
    "fitness",
    "nails_lashes"
  ]
};

export const DEFAULT_CITY_SLUG = "london";
export const DEFAULT_NICHE_SLUG = "food_reviewers";

export const normalizeLookupText = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[_-]+/g, " ")
    .replace(/[^a-z0-9\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export const toSlug = (value) =>
  normalizeLookupText(value).replace(/\s+/g, "_");

export const findLaunchCityBySlug = (slug) =>
  LAUNCH_CITY_INDEX.find((item) => item.slug === String(slug || "").toLowerCase()) || null;

export const findLaunchNicheBySlug = (slug) =>
  LAUNCH_NICHE_INDEX.find((item) => item.slug === String(slug || "").toLowerCase()) || null;

export const getLaunchNicheSlugsForCity = (citySlug) => {
  const slug = String(citySlug || "").toLowerCase().trim();
  return LAUNCH_SEGMENT_INDEX[slug] || [];
};

export const getLaunchNichesForCity = (citySlug) => {
  const allowedSlugs = getLaunchNicheSlugsForCity(citySlug);

  if (!citySlug) return LAUNCH_NICHE_INDEX;
  if (!allowedSlugs.length) return [];

  const allowed = new Set(allowedSlugs);
  return LAUNCH_NICHE_INDEX.filter((item) => allowed.has(item.slug));
};

export const isValidLaunchSegment = (citySlug, nicheSlug) => {
  const allowedSlugs = getLaunchNicheSlugsForCity(citySlug);
  return allowedSlugs.includes(String(nicheSlug || "").toLowerCase().trim());
};

export const findLaunchCityByAny = (value) => {
  const raw = String(value || "").trim();
  const slug = toSlug(raw);
  const text = normalizeLookupText(raw);

  return (
    LAUNCH_CITY_INDEX.find((item) => item.slug === slug) ||
    LAUNCH_CITY_INDEX.find((item) =>
      item.aliases?.some((alias) => normalizeLookupText(alias) === text)
    ) ||
    LAUNCH_CITY_INDEX.find((item) =>
      item.aliases?.some((alias) => normalizeLookupText(alias).includes(text))
    ) ||
    null
  );
};

export const findLaunchNicheByAny = (value) => {
  const raw = String(value || "").trim();
  const slug = toSlug(raw);
  const text = normalizeLookupText(raw);

  return (
    LAUNCH_NICHE_INDEX.find((item) => item.slug === slug) ||
    LAUNCH_NICHE_INDEX.find((item) =>
      item.aliases?.some((alias) => normalizeLookupText(alias) === text)
    ) ||
    LAUNCH_NICHE_INDEX.find((item) =>
      item.aliases?.some((alias) => normalizeLookupText(alias).includes(text))
    ) ||
    null
  );
};

export const deriveLaunchCitySlug = (value, fallback = DEFAULT_CITY_SLUG) =>
  findLaunchCityByAny(value)?.slug || fallback;

export const deriveLaunchNicheSlug = (value, fallback = DEFAULT_NICHE_SLUG) =>
  findLaunchNicheByAny(value)?.slug || fallback;

export const labelForLaunchCitySlug = (slug) =>
  findLaunchCityBySlug(slug)?.name || String(slug || "").replace(/_/g, " ");

export const labelForLaunchNicheSlug = (slug) =>
  findLaunchNicheBySlug(slug)?.name || String(slug || "").replace(/_/g, " ");

export const CITY_INDEX = LAUNCH_CITY_INDEX;
export const NICHE_INDEX = LAUNCH_NICHE_INDEX;

export const WAVE_2_CITY_INDEX = [];
export const WAVE_2_NICHE_INDEX = [];

export const findCityBySlug = findLaunchCityBySlug;
export const findNicheBySlug = findLaunchNicheBySlug;

export const labelForCitySlug = labelForLaunchCitySlug;
export const labelForNicheSlug = labelForLaunchNicheSlug;
